import React from "react";
import { Building2, Rocket, Server } from "lucide-react";

const DYNICTY_LOGO = "/brand/dynicty-logo-official.webp";
const DYNI = { png: "/brand/auth/welcome.png", webp: "/brand/auth/welcome.webp" };

const CAPABILITIES = [
  { Icon: Building2, title: "Manage Tenants", sub: "Provision & monitor stores", color: "#67e8f9", bg: "rgba(6,182,212,0.2)", border: "rgba(0,210,255,0.3)" },
  { Icon: Rocket, title: "Deploy Stores", sub: "Templates to production", color: "#a5b4fc", bg: "rgba(99,102,241,0.2)", border: "rgba(129,140,248,0.3)" },
  { Icon: Server, title: "Control Infrastructure", sub: "Environments & domains", color: "#f0abfc", bg: "rgba(217,70,239,0.2)", border: "rgba(232,121,249,0.3)" },
];

/* Platform Owner identity panel (desktop only). Dynicty-owned — no tenant branding. */
export function PlatformBrandPanel({ tagline }) {
  return (
    <section className="hidden lg:flex lg:col-span-7 flex-col justify-center select-none" data-testid="platform-brand-panel">
      <img src={DYNICTY_LOGO} alt="Dynicty" className="h-24 w-auto object-contain object-left -ml-3 mb-6 dyn-rise" data-testid="platform-dynicty-logo" />
      <div className="space-y-3 max-w-xl dyn-rise dyn-rise-1">
        <div className="text-xs font-black uppercase tracking-[0.28em]" style={{ color: "#94a3b8" }}>{tagline}</div>
        <h1 className="text-4xl xl:text-5xl font-extrabold tracking-tight text-white leading-tight">
          Your Commerce<br /><span className="dyn-gradient-text">Control Center</span>
        </h1>
        <p className="text-sm xl:text-base leading-relaxed max-w-lg" style={{ color: "#cbd5e1" }}>
          Manage tenants, templates, deployments and infrastructure from one unified platform.
        </p>
      </div>

      <div className="relative mt-8 min-h-[340px] flex items-center">
        <div className="flex flex-col gap-3.5 z-10 w-72 shrink-0 dyn-rise dyn-rise-2">
          {CAPABILITIES.map((c) => (
            <div key={c.title} className="dyn-glass-pill p-2.5 px-3.5 rounded-2xl flex items-center gap-3.5" data-testid={`platform-cap-${c.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{ background: c.bg, border: `1px solid ${c.border}`, boxShadow: `0 0 15px ${c.bg}`, color: c.color }}>
                <c.Icon size={20} />
              </div>
              <div>
                <p className="text-sm font-bold text-white leading-snug">{c.title}</p>
                <p className="text-xs" style={{ color: "#94a3b8" }}>{c.sub}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="relative flex-1 flex items-center justify-center dyn-rise dyn-rise-3">
          <div className="relative z-10 dyn-float-slow">
            <div className="absolute inset-0 rounded-full scale-90" style={{ background: "linear-gradient(45deg, rgba(0,210,255,0.3), rgba(99,102,241,0.2), transparent)", filter: "blur(40px)" }} />
            <picture>
              <source srcSet={DYNI.webp} type="image/webp" />
              <img src={DYNI.png} alt="Dyni, maskot Dynicty" className="w-64 xl:w-72 h-auto object-contain relative z-10" style={{ filter: "drop-shadow(0 15px 35px rgba(0,210,255,0.4))" }} data-testid="platform-dyni-mascot" />
            </picture>
            <div className="absolute -left-10 top-4 dyn-glass-card px-3.5 py-2.5 rounded-2xl rounded-tr-none text-left max-w-[160px] z-20" style={{ borderColor: "rgba(0,210,255,0.4)", boxShadow: "0 4px 20px rgba(0,210,255,0.2)" }}>
              <p className="text-xs font-extrabold" style={{ color: "#67e8f9" }}>Welcome back, <span className="text-white">Owner!</span></p>
              <p className="text-[11px] leading-tight mt-0.5" style={{ color: "#cbd5e1" }}>Everything is under control.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4 pt-3 flex items-center justify-between dyn-rise dyn-rise-4" style={{ borderTop: "1px solid rgba(255,255,255,0.05)" }}>
        <div className="text-lg font-bold tracking-wide -rotate-2" style={{ color: "#67e8f9", textShadow: "0 0 8px rgba(0,210,255,0.4)" }}>Build. Grow. Empower.</div>
        <div className="text-xs tracking-wider italic" style={{ color: "#94a3b8" }}>Dynicty Platform Owner Portal</div>
      </div>
    </section>
  );
}
